import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { throttle } from 'throttle-debounce';
import { THUMBNAIL_LIST_EARS } from '../../../../shared/constants';
import { getCoordinates, getNodeOffset, getUniversalPosition, toggleCursorStyles } from '../../../../shared/helpers';
import { isClick } from '../../../../shared/helpers/isClick';
import * as styles from './styles.css';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var Thumbnails = /*#__PURE__*/function (_React$Component) {
  _inherits(Thumbnails, _React$Component);
  var _super = _createSuper(Thumbnails);
  function Thumbnails() {
    var _this;
    _classCallCheck(this, Thumbnails);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "elementListRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "elementListOffset", 0);
    _defineProperty(_assertThisInitialized(_this), "containerRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "lastCursorPosition", {
      x: 0,
      y: 0
    });
    _defineProperty(_assertThisInitialized(_this), "isScrolling", false);
    _defineProperty(_assertThisInitialized(_this), "handleMoveStart", function (e) {
      _this.toggleMove(true);
      _this.lastCursorPosition = getUniversalPosition(e.nativeEvent);
    });
    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.goToElement(_this.props.activeIndex);
    });
    _defineProperty(_assertThisInitialized(_this), "throttledHandleMoveStart", throttle(100, _this.handleMoveStart));
    _defineProperty(_assertThisInitialized(_this), "throttedResizeHandler", throttle(100, _this.handleResize));
    _defineProperty(_assertThisInitialized(_this), "handleMoveStartPersisted", function (e) {
      e.persist();
      _this.throttledHandleMoveStart(e);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleMove", function (on) {
      var togglerFn = on ? window.addEventListener : window.removeEventListener;
      if (on) {
        _this.changeSlidesContainerTransition('none');
      }
      _this.isScrolling = on;
      toggleCursorStyles(on, _this.elementListRef);
      togglerFn('contextmenu', _this.handleMoveEnd);
      togglerFn('mouseup', _this.handleMoveEnd);
      togglerFn('touchend', _this.handleMoveEnd);
      togglerFn('mousemove', _this.handleMove);
      togglerFn('touchmove', _this.handleMove);
    });
    _defineProperty(_assertThisInitialized(_this), "changeSlidesContainerTransition", function (newValue) {
      _this.elementListRef.current.style.transition = newValue;
    });
    _defineProperty(_assertThisInitialized(_this), "handleMoveEnd", function (e) {
      if (!_this.isScrolling) {
        return;
      }
      var _getCoordinates = getCoordinates(e, _this.lastCursorPosition),
        deltaX = _getCoordinates.deltaX;
      _this.toggleMove(false);
      var shift = _this.getShift(deltaX);
      if (shift === Infinity) {
        _this.goToElement(_this.props.thumbnails.length - 1);
      } else if (shift === -Infinity) {
        _this.goToElement(0);
      } else {
        _this.setElementListOffset(shift, true);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMove", function (e) {
      var _getCoordinates2 = getCoordinates(e, _this.lastCursorPosition),
        deltaX = _getCoordinates2.deltaX;
      var shift = _this.getShift(deltaX, true);
      if (!_this.isScrolling || !isFinite(shift)) {
        return;
      }
      _this.setElementListOffset(shift);
    });
    _defineProperty(_assertThisInitialized(_this), "getShift", function (deltaX) {
      var withEars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var shift = _this.elementListOffset + -deltaX;
      var ear = withEars ? THUMBNAIL_LIST_EARS : 0;
      if (shift > ear) {
        return -Infinity;
      }
      if (-shift >= _this.elementListRef.current.offsetWidth - _this.containerRef.current.offsetWidth + ear) {
        return Infinity;
      }
      return shift;
    });
    _defineProperty(_assertThisInitialized(_this), "goToElement", function (index) {
      var max = _this.elementListRef.current.offsetWidth - _this.containerRef.current.offsetWidth;
      _this.changeSlidesContainerTransition("transform ease-in-out 150ms");
      var childNode = _this.elementListRef.current.childNodes[index];
      var offset = childNode ? getNodeOffset(childNode) : 0;
      var target = offset > max ? max : offset;
      _this.setElementListOffset(-target, true);
    });
    _defineProperty(_assertThisInitialized(_this), "setElementListOffset", function (shift) {
      var setOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (setOffset) {
        _this.elementListOffset = shift;
      }
      _this.elementListRef.current.style.transform = "translateX(".concat(shift, "px)");
    });
    _defineProperty(_assertThisInitialized(_this), "onThumbnailClick", function (index) {
      return function (e) {
        var currentPosition = getUniversalPosition(e.nativeEvent);
        if (!isClick(_this.lastCursorPosition, currentPosition)) {
          return;
        }
        _this.props.onThumbnailClick(index + 1);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "updateElementListWidth", function () {
      var elementList = _this.elementListRef.current;
      var child = elementList === null || elementList === void 0 ? void 0 : elementList.childNodes[_this.props.thumbnails.length - 1];
      if (!elementList || !child) {
        return false;
      }
      var width = "".concat(getNodeOffset(child) + child.offsetWidth, "px");
      elementList.style.width = width;
      return width;
    });
    return _this;
  }
  _createClass(Thumbnails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateElementListWidth();
      this.goToElement(this.props.activeIndex);
      window.addEventListener('resize', this.throttedResizeHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.throttedResizeHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        activeIndex = _this$props.activeIndex,
        thumbnails = _this$props.thumbnails;
      if (thumbnails.length !== prevProps.thumbnails.length) {
        this.updateElementListWidth();
      }
      if (activeIndex !== prevProps.activeIndex) {
        this.goToElement(activeIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        thumbnails = _this$props2.thumbnails,
        activeIndex = _this$props2.activeIndex;
      return /*#__PURE__*/_jsx("div", {
        className: styles['layout'],
        children: /*#__PURE__*/_jsx("div", {
          className: styles['container'],
          onMouseDown: this.handleMoveStartPersisted,
          onTouchStart: this.handleMoveStartPersisted,
          ref: this.containerRef,
          children: /*#__PURE__*/_jsx("div", {
            ref: this.elementListRef,
            className: styles['element_list'],
            children: thumbnails.map(function (node, index) {
              return /*#__PURE__*/_createElement("div", _objectSpread(_objectSpread({}, mergeStyles(styles['element'], activeIndex === index && styles['element--active'])), {}, {
                onClick: _this2.onThumbnailClick(index),
                key: index
              }), node);
            })
          })
        })
      });
    }
  }]);
  return Thumbnails;
}(React.Component);